import { ourprocess } from "./process"
import teens from '../assets/teens.jpg'

const images = [
	// 'https://images.unsplash.com/photo-1573497491208-6b1acb260507?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
	'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
	teens
	// 'https://images.unsplash.com/photo-1629360021730-3d258452c425?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
	// 'https://images.unsplash.com/photo-1670272506173-0b0be082a52f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80',
]
export const slides = [

	{
		bgImg: 'https://images.unsplash.com/photo-1535043883-2548fb805573?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
		heading: 'Welcome to SMARTA!',
		subs: [
			'We are your No.1 developmental hub for teenagers that thrive!',
			'We offer a variety of services for teenagers including Mentorship, Book Club, Counseling and Coaching Programs.'
		]
	},
	...ourprocess.map(({ text, title }, i) => (
		{
			bgImg: images[i] ? images[i] : images[0],
			heading: title,
			subs: [text]
		})
	)

]